// Import the functions you need from the SDKs you need
import { FIREBASE_CONFIG } from '@config/index';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';
import { getStorage } from "firebase/storage";

// Initialize Firebase 
export const FirebaseApp = initializeApp(FIREBASE_CONFIG);
export const FirebaseAuth = getAuth(FirebaseApp);
export const FirebaseDB = getFirestore(FirebaseApp);
export const FirebaseStorage = getStorage(FirebaseApp);